export const panoramasReducer = (state = [], action) => {
    switch (action.type) {
        case 'INIT_PANORAMA':
            return [...action.payload];
        case 'ADD_PANORAMA':
            return [...action.payload];
        case 'DELETE_PANORAMA':
            return [...action.payload];
        default:
            return state;
    }
};

export const currentPanoramaReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_PANORAMA':
            return { ...action.payload };
        default:
            return state;
    }
};
